import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

import { getStudyInNativeLanguage } from 'features/User/selectors';
import { updateStudyInNativeLanguage } from 'features/User/actions';

export const useConversationSettingsService = () => {
  const dispatch = useDispatch();
  const studyInNativeLanguage = useSelector(getStudyInNativeLanguage);

  const handleToggleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updateStudyInNativeLanguage(event.target.checked));
    },
    [dispatch]
  );

  return {
    studyInNativeLanguage,
    handleToggleChange,
  };
};